import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class MoneySourceEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) {
	}

	loadMoneySource(token, ID) {
		return this.http
		.get(this.apiUrl + "moneysource/v1/get/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editMoneySource(token, moneySource: any) {
		return this.http
		.put(this.apiUrl + "moneysource/v1/update", moneySource, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/money-source/service/money-source-edit/money-source-edit.service.ts